export enum ServiceEnum {
    VIDEO_SERVICES = 'video_services',
    IMAGE_PROCESSING = 'image_processing',
    FLOORPLAN_SERVICES = 'floorplan_services'
}
